export const environment = {
  production: false,
  apiUrl: '/legacy',
  pdfUrl: 'https://izia.pdf.dev.synapsia.fr/',
} as const;
